export class RevenueArcInfo {
  public ArcId: number;
  public Descr: string;

  public constructor() {
    this.ArcId = 0;
    this.Descr = '';
  }
}
